// extracted by mini-css-extract-plugin
export default {"statusTag":"status-tag_statusTag__wzU-v","active":"status-tag_active__vKQRD","suspended":"status-tag_suspended__sEUev"};